import 'rc-slider/dist/rc-slider.css'
import React from 'react'
// import ReactDOM from 'react-dom'
import { createRoot } from 'react-dom/client'
import 'react-quill/dist/quill.snow.css'
import 'react-select/dist/react-select.css'
import { startSession } from '@futures-platform/connectors/session'
import { GlobalStyles } from '@futures-platform/ui'
import App from './App'
import './index.css'
import { DataProvider } from './store/GlobalState'

const renderApp = (dataUri) => {
  const params = !!dataUri && dataUri?.split('/')
  if (!!params) {
    return (
      <React.StrictMode>
        <GlobalStyles />
        <DataProvider gid={Number(params[1])} ssid={params[2]} sid={params[3]}>
          <App
            gid={Number(params[1])}
            ssid={params[2]}
            sid={params[3]}
            uri={dataUri}
          />
        </DataProvider>
      </React.StrictMode>
    )
  }
}

startSession().then(() => {
  const appElements = document.getElementsByClassName('scenario-card-app')

  for (let el of appElements) {
    if (!!el.hasAttribute('data-uri')) {
      const root = createRoot(el)
      root.render(renderApp(el.getAttribute('data-uri')))
    }
  }
})

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
